import { useState, useEffect } from "react";
import { useCart } from "./CartContext";
import { db } from "../firebase";
import { serverTimestamp, collection, addDoc } from "firebase/firestore";

function Checkout() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    postalCode: "",
    paymentMethod: "cod",
  });

  const [errors, setErrors] = useState({});
  const { cart, setCart, removeFromCart } = useCart();
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.fullName.trim()) newErrors.fullName = "Please enter full name";
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) newErrors.email = "Invalid email";
    if (!form.phone.trim()) newErrors.phone = "Please enter phone";
    if (!form.address.trim()) newErrors.address = "Please enter address";
    if (!form.city.trim()) newErrors.city = "Please enter city";
    if (!form.postalCode.trim()) newErrors.postalCode = "Please enter postal code";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const orderData = {
      customer: form,
      items: cart,
      total,
      createdAt: serverTimestamp(),
    };

    try {
      await addDoc(collection(db, "orders"), orderData);
      setCart([]);
      localStorage.setItem("cart", JSON.stringify([]));
      console.log("Order placed successfully");
    } catch (err) {
      console.error("Error placing order:", err);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setForm((prev) => ({
          ...prev,
          fullName: parsedUser.fullName || "",
          email: parsedUser.email || "",
          phone: parsedUser.phone || "",
          address: parsedUser.address || "",
          city: parsedUser.city || "",
          postalCode: parsedUser.postalCode || "",
        }));
      } catch {
        console.error("Invalid user data in localStorage");
      }
    }
  }, []);

  return (
    <div className="container mt-5" style={{ maxWidth: "700px" , marginBottom: "10px"}}>
      <h2>Checkout</h2>
      <form onSubmit={handleSubmit} noValidate>
        <h4>Customer Information</h4>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Full Name</label>
          <div className="col-sm-8">
            <input
              name="fullName"
              type="text"
              className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
              value={form.fullName}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.fullName}</div>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Email</label>
          <div className="col-sm-8">
            <input
              name="email"
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              value={form.email}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.email}</div>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Phone</label>
          <div className="col-sm-8">
            <input
              name="phone"
              type="text"
              className={`form-control ${errors.phone ? "is-invalid" : ""}`}
              value={form.phone}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.phone}</div>
          </div>
        </div>

        <h4>Shipping Address</h4>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Address</label>
          <div className="col-sm-8">
            <input
              name="address"
              type="text"
              className={`form-control ${errors.address ? "is-invalid" : ""}`}
              value={form.address}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.address}</div>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">City</label>
          <div className="col-sm-8">
            <input
              name="city"
              type="text"
              className={`form-control ${errors.city ? "is-invalid" : ""}`}
              value={form.city}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.city}</div>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Postal Code</label>
          <div className="col-sm-8">
            <input
              name="postalCode"
              type="text"
              className={`form-control ${errors.postalCode ? "is-invalid" : ""}`}
              value={form.postalCode}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.postalCode}</div>
          </div>
        </div>

        <h4>Payment Method</h4>
        <div className="mb-3 row">
          <label className="col-sm-4 col-form-label">Select Method</label>
          <div className="col-sm-8">
            <select
              name="paymentMethod"
              className="form-select"
              value={form.paymentMethod}
              onChange={handleChange}
            >
              <option value="cod">Cash on Delivery (COD)</option>
              <option value="card">Credit/Debit Card</option>
              <option value="paypal">PayPal</option>
            </select>
          </div>
        </div>

        <h4>Order Summary</h4>
        <ul className="list-group mb-3">
          {cart.map((item) => (
            <li key={item.id} className="list-group-item d-flex justify-content-between align-items-center">
              <span>
                {item.name} x {item.quantity} — {item.price * item.quantity} Ks
              </span>
              <button
                type="button"
                onClick={() => removeFromCart(item.id)}
                style={{ background: "black", color: "white", border: "none", padding: "4px 8px" }}
              >
                Xóa
              </button>
            </li>
          ))}
          <li className="list-group-item d-flex justify-content-between">
            <strong>Total</strong>
            <strong>{total} Đ</strong>
          </li>
        </ul>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={cart.length === 0}
        >
          Place Order
        </button>
      </form>
    </div>
  );
}

export default Checkout;
